import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array)
{
  for (let i = array.length - 1; i > 0; i--)
  {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export default function Rating({ ...props })
{
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() =>
  {
    if (questions !== undefined)
    {
      let levelQs = [];
      questions.forEach((levelQuestions, i) =>
      {

        var newLevelQuestions = [];
        levelQuestions.forEach(q =>
        {
          //Fills in the question text complete with generated values
          let questionText = q.question.replace("$", "_");
          let questionLine2 = q.question_line_2;
          let incorrect = [q.option_1, q.option_2, q.option_3, q.option_4, q.option_5, q.option_6];
          let correct = [q.right_answer, q.text_1, q.text_2, q.text_3]

          console.log(incorrect);
          console.log(correct);


          //Creates an array of answers and fills in the correct answer
          let questionAnswers = [];
          for (var i = 0; i < correct.length; i++)
            if (correct[i] !== "" && correct[i] != null){
            if(correct[i].endsWith(" ")){

              correct[i] = correct[i].slice(0,-1);
              console.log(correct)
            }
            if(correct[i].startsWith(" ")){

              correct[i] = correct[i].slice(1,correct[i].length);
              console.log(correct)
            }

            


              questionAnswers.push({ correct: true, value: correct[i] });
          }
          var correctNo = questionAnswers.length;
          for (var i = 0; i < incorrect.length; i++)
            if (incorrect[i] !== "" && incorrect[i] != null)
            {
              if(incorrect[i].endsWith(" ")){

                incorrect[i] = incorrect[i].slice(0,-1);
                console.log(incorrect)
              }
              if(incorrect[i].startsWith(" ")){

                incorrect[i] = incorrect[i].slice(1,incorrect[i].length);
                console.log(incorrect)
              }

              

              var found = false;
              for (var o = 0; o < correct.length; o++)
                if (incorrect[i] == correct[o])
                  found = true;
              if (!found)
                questionAnswers.push({ correct: false, value: incorrect[i]});
            }

          //Shuffles the answer array
          shuffleArray(questionAnswers);

          //Creates object to return
          let questionObj = {
            question: questionText,
            question2: questionLine2,
            answers: questionAnswers,
            topic_id: q.topic_id
          };
          if(correctNo == 1)
            newLevelQuestions.push(questionObj);
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() =>
      {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
